import styled from 'styled-components';

import { Link, NavLink, media } from '@minerva-analytics/pantheon';
import Image from 'components/Image';

import { WHITE, BLUE } from 'root/theme';


const StyledImage = styled(Image)`
`;

const TutItem = styled.div`
  padding: 0 2rem;
  color: ${WHITE};
  width: 33%;
  display: inline-block;
  ${media.tablet`
    width: 100%;
    max-width: 320px;
    margin: 0 auto 1rem;
    display: block;
  `}
`;

const TutText = styled.div`
  margin-top: 1rem;
`;

const TutLink = styled(Link)`
  margin-top: 1rem;
  display: block;
  color: ${BLUE};
  text-decoration: none;
  background-color: ${WHITE};
  font-weight: 700;
  padding: 10px 25px;
  font-size: .9rem;
  border-radius: 30px;
`;

const TutNavLink = styled(NavLink)`
  margin-top: 1rem;
  display: block;
  color: ${BLUE};
  text-decoration: none;
  background-color: ${WHITE};
  font-weight: 700;
  padding: 10px 25px;
  font-size: .9rem;
  border-radius: 30px;
`;

const Title = styled.h2`
  font-size: 1.75rem;
  color: ${WHITE};
`;

const TutContainer = styled.div`
  background-color: ${BLUE};
  padding: 3rem 0 4rem;
  text-align: center;
`;

const TutPageWrap = styled.div`
  max-width: 1024px;
  width: 100%;
  margin: 0 auto;
  padding: 0 2rem;
`;

export {
  StyledImage,
  TutItem,
  TutText,
  TutLink,
  TutContainer,
  Title,
  TutNavLink,
  TutPageWrap,
};
